import ApiBase from './api-base'

class LandingPage extends ApiBase {
  constructor () {
    super()

    this.baseUrl = '/v2.4/landing_pages'
  }

  async get (path) {
    const url = `${this.baseUrl}/${path}`
    const { data } = await this.client.get(url)
    return data
  }
}

export default LandingPage
